import { FieldValues, UseFormWatch } from 'react-hook-form'

import { SchemaAttribute } from '@/Data/typesV2'

/**
 * Util function to help determining the `key` prop for the custom field.
 *
 * If the field type is `enum` | `multiEnum` the function will `watch` for changes
 * in the value, and return a dynamic key to re-render the component
 * @param attribute
 * @param watch
 * @param schemaAttribute
 * @returns
 */
export const getCustomFieldKey = (
  attribute: string,
  schemaAttribute?: SchemaAttribute,
  watch?: UseFormWatch<FieldValues>,
) => {
  if (!watch) return attribute

  if (
    schemaAttribute?.type === 'enum' ||
    schemaAttribute?.type === 'enumarray'
  ) {
    const watchArray = [
      ...new Set(
        schemaAttribute.enumValues?.flatMap((e) =>
          Object.keys(e.constraints ? e.constraints : {}),
        ),
      ),
    ].filter((e) => e !== attribute)

    return `${attribute}-${watch(watchArray).toString()}`
  }

  return attribute
}
